import { render, staticRenderFns } from "./LoginCertificados.vue?vue&type=template&id=f7883d74&scoped=true&"
import script from "./LoginCertificados.vue?vue&type=script&lang=js&"
export * from "./LoginCertificados.vue?vue&type=script&lang=js&"
import style0 from "./LoginCertificados.vue?vue&type=style&index=0&id=f7883d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7883d74",
  null
  
)

export default component.exports